<template>
	<div class="p-select-item">
		<i v-if="close" class="p-icon p-icon-close" @click="$emit('close-click')"/>
		<i v-if="isIcon" class="p-icon" :class="`p-icon-${icon}`" @click="$emit('icon-click')"/>
		<span class="p-select-item-label">{{ name }}</span>
	</div>	
</template>

<script setup lang="ts">
import { computed } from 'vue';
interface Props {
	item: object | string | number,
	isIcon?: boolean|string,
	close?: boolean
}

const props = defineProps<Props>();

const name = computed(() => 
  typeof props.item === 'object' ? props.item.name : String(props.item)
);

const icon = computed(() => 
  typeof props.isIcon === 'string' ? props.isIcon : name
);
</script>
